import { render, staticRenderFns } from "./BandejaClasificacionComponente.vue?vue&type=template&id=424fed94"
import script from "./BandejaClasificacionComponente.vue?vue&type=script&lang=js"
export * from "./BandejaClasificacionComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports